<template>
  <small
    aria-invalid="true"
    class="inline-block text-sm text-error-01"
    data-testid="clr-error-text"
  >
    <slot />
  </small>
</template>
